import { Building2, MapPin, CalendarDays, ArrowRight } from "lucide-react";
import { SectionHeading } from "./SectionHeading";
import { Reveal } from "./Reveal";
import { scrollToSection } from "./Navbar";

const InfoRow = ({ icon: Icon, label, value, testId }) => (
  <div className="flex items-start gap-4 border-b border-slate-100 py-4 last:border-0">
    <div className="flex h-10 w-10 shrink-0 items-center justify-center rounded-xl bg-brand-mist">
      <Icon className="h-5 w-5 text-brand" />
    </div>
    <div>
      <p className="text-xs font-semibold uppercase tracking-[0.15em] text-slate-500">{label}</p>
      <p className="mt-1 text-sm font-medium text-brand-dark" data-testid={testId}>{value}</p>
    </div>
  </div>
);

export default function About({ content }) {
  const c = content.company;
  return (
    <section id="tentang" className="bg-fade-blue py-24" data-testid="about-section">
      <div className="mx-auto grid max-w-7xl items-center gap-14 px-4 sm:px-6 lg:grid-cols-2">
        <Reveal className="relative">
          <div className="overflow-hidden rounded-3xl">
            <img
              src={c.image}
              alt="Keluarga di depan rumah baru — PT. Cahaya Sakofa Mulia"
              className="aspect-[4/5] w-full object-cover object-bottom transition-transform duration-700 hover:scale-105 sm:aspect-[5/5]"
              loading="lazy"
            />
          </div>
          <div className="absolute -bottom-6 -right-2 hidden rounded-2xl bg-brand p-6 text-white shadow-xl sm:block">
            <p className="font-display text-3xl font-extrabold">Type 36</p>
            <p className="mt-1 text-xs uppercase tracking-[0.2em] text-white/80">Fokus Pengembangan</p>
          </div>
        </Reveal>

        <div>
          <SectionHeading number="01" eyebrow="Tentang Kami" title={c.title} />
          <Reveal delay={0.1}>
            <p className="-mt-6 text-base leading-relaxed text-slate-600" data-testid="about-description">
              {c.description}
            </p>
            <div className="mt-8">
              <InfoRow icon={CalendarDays} label="Tahun Berdiri" value={c.foundedYear} testId="about-founded" />
              <InfoRow icon={MapPin} label="Alamat Kantor" value={c.address} testId="about-address" />
              <InfoRow icon={Building2} label="Bidang Usaha" value="Pengembangan & Pemasaran Perumahan Type 36 Cluster" testId="about-field" />
            </div>
            <button
              onClick={() => scrollToSection("#kontak")}
              data-testid="about-more-button"
              className="mt-8 inline-flex items-center gap-2 rounded-full border-2 border-brand px-6 py-3 text-sm font-semibold text-brand transition-colors duration-200 hover:bg-brand hover:text-white active:scale-95"
            >
              Selengkapnya Tentang Kami
              <ArrowRight className="h-4 w-4" />
            </button>
          </Reveal>
        </div>
      </div>
    </section>
  );
}
